export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Family caring for elderly parent"
          className="w-full h-full object-cover"
          src="https://readdy.ai/api/search-image?query=Warm%20family%20gathering%20around%20elderly%20parent%20in%20cozy%20home%20setting%2C%20soft%20natural%20light%2C%20caring%20embrace%2C%20navy%20and%20green%20color%20tones%2C%20editorial%20lifestyle%20photography%20with%20warm%20neutral%20background%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=hero-1&orientation=landscape"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-500/85 via-primary-500/70 to-primary-500/85"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-20 pt-28">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center mb-8">
            <div className="w-56 h-56 md:w-80 md:h-80 bg-white/10 rounded-full flex items-center justify-center p-2">
              <img
                alt="CareBridge"
                className="w-full h-full object-contain"
                src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/ce833f012c3f23716ee4b56643f21003.png"
              />
            </div>
          </div>
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <i className="ri-heart-pulse-line text-accent-400 text-sm"></i>
            <span className="text-sm text-white font-medium text-shadow-soft">Connecting families. Supporting care.</span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 text-shadow-soft">
            CareBridge: The Simple App That Helps Families Care for Elderly Parents
          </h1>
          <p className="text-lg md:text-xl text-white/95 max-w-2xl mx-auto mb-10 leading-relaxed text-shadow-soft">
            Medication reminders, meal tracking, doctor visits, family check-ins, caregiver updates, and emergency alerts — all in one easy-to-use app.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <a
              href="https://carebridge4elderly.base44.app" target="_blank" rel="nofollow noopener noreferrer"
              className="w-full sm:w-auto bg-secondary-500 text-white font-semibold px-8 py-4 rounded-full hover:bg-secondary-600 transition-all cursor-pointer whitespace-nowrap text-base shadow-lg"
            >
              Join the App
            </a>
            <button className="w-full sm:w-auto bg-white text-primary-500 font-semibold px-8 py-4 rounded-full hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap text-base border border-white/20">
              <span className="flex items-center gap-2">
                <i className="ri-play-circle-line text-primary-500"></i>
                See How It Works
              </span>
            </button>
          </div>
          <p className="text-sm text-white/85 max-w-xl mx-auto text-shadow-soft">
            Designed for elderly parents, families, and caregivers who want peace of mind without complicated technology.
          </p>
        </div>
      </div>
    </section>
  );
}